/* --------------------------------------------------------------------------------------
   tests.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const testsComponent  = {
    template: require('./tests.html'),
    controller: 'testsCtrl',
    controllerAs: 'vm',
    bindings: {
      back: '&',
      next: '&'
    }
}

export class testsCtrl {
  /*@ngInject*/
  constructor (commonService, dataService, appService) {
    this.commonService = commonService
    this.dataService = dataService
    this.appService = appService
  }
  $onInit () {
    this.commonService.setDefaultBackground()
    this.className = this.appService.className
    this.dataService.GetTests(this.appService.classId)
      .then(result => this.setItems(result))
      .then(items => this.setSegmentedSizesAndScroll(items.length))
      .catch(error => {
        this.appService.handleError(error)
          .then(result => {this.error = result})
      })
  }
  setSegmentedSizesAndScroll(itemCount) {
    this.width = (this.commonService.getScreenWidth() > 801)? '935':'760'
    let maxVisibleItems = (this.commonService.getScreenHeight() > 481)? 7:5
    let maxHeight = (this.commonService.getScreenHeight() > 481)? '484':'350'
    if (itemCount <= maxVisibleItems) {
      this.scroll = false
    }
    else {
      this.scroll = true
      this.height = maxHeight
    }
    this.ready = true
  }
  setItems(items) {
    this.items = items
    this.selectedTest = this.items[0]
    return items
  }
  selectTest(item) {
    this.selectedTest = {ID: item.value, Name: item.label}
  }
  submit() {
    this.appService.testId = this.selectedTest.ID
    this.appService.testName = this.selectedTest.Name
    this.next()
  }
  errorClosed() {
    return this.appService.errorClosed(this.error)
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/tests.component.js